export enum RedirectToDialogBox {
    CreateNewOrder = 'createNewOrder',
    ManageFavouriteSamples = 'manageFavouriteSamples',
    ViewQuotations = 'viewQuotations',
    OrderFromFavourite = 'orderFromFavourite',
    OrderingConfigurations = 'orderingConfigurations'
}
